module.exports = __webpack_public_path__ + "static/media/contained-rounder.f959e895.svg";